import React from "react";
import Header from "../../SubComponents/Header";
import QuotePrezident from "../../SubComponents/SubHomeComponents/QuotePrezident";
import SliderHome from "../../SubComponents/SubHomeComponents/SliderHome";
import ContactUs from "../../SubComponents/contact";
import Footer from "../../SubComponents/footer";
import NewsList from "../../SubComponents/news_list";
import Regions from "../../SubComponents/regions";
import "./home.css";
import Video from "../../assets/img/welcome.mp4";

import SingleWindow from "../../components/SingleWindow/index";
import AdvantagesSection from "../../components/AdvantagesSection/index";
import StatisticsSection from "../../components/StatisticsSection/index";
import TajikistanEconomicStats from "../../components/TajikistanEconomicStats/index";

const Home = () => {
  return (
    <>
      <div className="backgroundVideo">
        <video autoPlay loop muted className="background-video">
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
        <div className="content">
          <Header />
          <SliderHome />
        </div>
      </div>
      <QuotePrezident />
      <StatisticsSection />
      <AdvantagesSection />
      <TajikistanEconomicStats />
      <SingleWindow />
      <Regions />
      <NewsList />
      <ContactUs />
      <Footer />
    </>
  );
};

export default Home;
